module.exports = {
  content: {
    popularRecommendation: "热门推荐",
    buy: "售卖",
    aboutEMarket: "关于 YayTech",
    aboutUs: "关于我们",
    registerSeller: "卖家 - 注册销售",
    sellerPortal: "卖家门户",
    help: "帮助",
    FAQs: '常见问题',
    customerService: "客户服务",
    termsConditions: " 使用条款",
    privacyPolicy: "隐私政策",
    shippingPolicy: "一年有限保修",
    afterSalespolicy: "售后政策",
    limitedWarranty: "一年有限保修",
    contactUs: "联系我们",
    phone: "800-893-9598,Mon - Fri: 8am - 5pm (PST)",
    address: "13771 Norton Ave, Chino, CA 91710",
    link: "support@xxxx.com",
    copy: "© Copyright 2021. All rights reserved.",
  },
  subscribe: {
    title: "YayTech新手?",
    dec: "订阅我们的时事通讯以获取有关我们最新优惠的更新！",
    btn: "订阅",
    text: "请输入电邮地址",
    paytitle: "支付方式",
    payText: "付款 100% 安全",
    FollowUsNow: '立即关注我们'
  },
  comment: {
    customerReviews: "顾客评论",
    dec: "YayTech是购买二手技术的安全、简单的市场。",
    content: `你好！ 我们是 YayTech，领先的二手电子设备市场。 我们的任务？ 通过赋予专业检测或 <br /> 维修设备第二次生命，实现我们“没有电子垃圾填埋场的世界”的终极梦想。`
  },
  MainHomePage: {
    Shipping: '今天的交易——都是免费送货',
    Recommendation: '流行产品推荐',
    stores: '今天推荐的商店',
    EMarket: '谁是YayTech？',
    Guarantee: '我们的保证',
    Payments: '100%担保付款',
    guarantee: '30天退款保证',
    warranty: '1年最低保修期',
    FreeShipping: '免费送货',
    Cellphone: '手机',
    iPad: 'iPad',
    Tablets: '平板',
    Laptops: '笔记本电脑',
    Macs: '苹果',
    Introduction: '为什么选择 YayTech',
    Huachuang: 'YayTech 再次让翻新技术变得更酷。 消费者越来越意识到新技术的持续消费对环境的长期影响。 越来越多的人希望以更优惠的价格购买翻新设备，因为延长任何产品生命周期意味着它不再前往垃圾填埋场或我们的海洋。 YayTech 致力于为所提供的每种产品提供最佳价值。 每一件产品都经过认真细致的翻新，让它再次焕然一新。 此外，YayTech 购物者会发现市场上种类最多的产品之一，并且在 YayTech 上购买的设备价格最低、发货速度快且保证免费退货。 如果出现任何问题，我们将在首次购买设备后的 1 年内免费维修设备。 可以说，有很多理由对 YayTech 说“耶！”。',
    electronic: 'YayTech平台上的所有电子产品均经过严格的质量检测、专业维修或翻新。 在这里您可以享受电子产品50-80%的折扣！',
    partners: '我们的合作伙伴是电子专家，他们在出厂前测试并验证每个产品的功能 100%。',
    hassle_free: '30 天无忧退货',
    Once: '收到商品后，您有 30 天的时间对其进行试运行。 如果它不符合您的期望，请将其退回。 就那么简单。',
    shipping: '免运费',
    Almost: '几乎所有产品都免费送货。 所以你支付你想要的，而不是支付运费。',
    refurbisher: '12 个月的翻新机保修',
    replace: '如有缺陷，该物品可以免费维修。 如果无法修复，我们将更换。',
    support: '客户关怀支持',
    business: '如果您有任何疑问或问题，我们的业务将在 1 个工作日内回复您。 如果我们不这样做，我们会支持您并帮助您解决问题。'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/footer.js